import React from "react";  

import {  
    
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import DashboardFormsRevenueAdd from "components/Dashboard/Forms/RevenueAdd";

export default function DashboardFormRevenueAdd(){  

    const history = useHistory(); 
    const navigate = to => history.push(`/${ to }`); 

    return ( 
        <>
            <ContainerAuthenticated page={"revenues"}> 
                <Row> 
                    <Col sm={12} md={12}>
                        <DashboardFormsRevenueAdd />
                    </Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}